import { apiClient } from '@app/lib'
import { type ApiDocumentsUploadInput, type ApiResponse } from '@app/types'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useState } from 'react'

export const useUploadDocuments = () => {
  const queryClient = useQueryClient()
  const [progress, setProgress] = useState(0)
  const mutation = useMutation({
    mutationKey: ['uploadDocuments'],
    mutationFn: async (input: ApiDocumentsUploadInput) => {
      // noinspection JSUnusedGlobalSymbols
      const response = await apiClient.post<ApiResponse>('/api/documents/upload', input, {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        onUploadProgress: (ev) => {
          if (ev.total) {
            setProgress(Math.round((ev.loaded * 100) / ev.total))
          }
        },
        validateStatus: (status) => status >= 200 && status < 500
      })

      return response?.data
    },
    onSuccess: () =>
      queryClient.invalidateQueries({
        queryKey: ['documents']
      })
  })

  return { ...mutation, progress }
}
